/**
 * Angular runtime global shim.
 *
 * Compiled Angular library bundles (e.g. `@klaro/ui`, `@klaro/theme` fesm2022)
 * reference the build-time global `ngDevMode` directly — the CLI replaces it
 * during production builds, and `@angular/core` defines it as a side-effect
 * at runtime in dev. But native-federation loads remote chunks before
 * `@angular/core` has finished its side-effects, so a service constructed
 * during federation hydration can hit `signal(...)` / `input(...)` factories
 * that throw `ReferenceError: ngDevMode is not defined`.
 *
 * Setting the global here — in a side-effect module that's the first import
 * in `main.ts` — guarantees every downstream chunk sees a defined value.
 * `??=` keeps a CLI-injected value (production builds inline `false`) intact.
 */
(globalThis as { ngDevMode?: boolean | object }).ngDevMode ??= true;
